module.exports = __webpack_public_path__ + "static/media/young1_v2.9a9472e6.jpg";